import { Polygon, Marker } from '@react-google-maps/api'
import iconNotSelected from 'assets/default/svg/iconNotSelected.svg'
import iconSelected from 'assets/default/svg/iconSelected.svg'
import iconSeen from 'assets/default/svg/iconSeen.svg'
import { useAppSelector } from 'redux/hooks'
import LatLng from 'interfaces/LatLng'
import useGoogleMap from 'hooks/useGoogleMap'
import { makeSelectZoom } from 'redux/features/map/selectors'
import s from './PolygonMarker.module.scss'

interface Props {
  center: LatLng
  coordGlobal: LatLng[]
  isSelected?: boolean
  isMarkedAsSeen?: boolean
  onClick?: () => void
}

const defaultProps = {
  isSelected: false,
  isMarkedAsSeen: false,
  onClick: () => null,
}

const PolygonMarker = ({
  center,
  coordGlobal,
  isSelected,
  isMarkedAsSeen,
  onClick,
}: Props): JSX.Element => {
  const zoom = useAppSelector(makeSelectZoom)
  const map = useGoogleMap()
  const releaseToggleV2 = process?.env?.REACT_APP_RELEASE_TOGGLE_V2 === 'true'

  const iconPin = {
    url: iconNotSelected,
  }
  if (releaseToggleV2 && isMarkedAsSeen) iconPin.url = iconSeen

  const pathOptions = {
    strokeColor: s.colorParcelle,
    strokeOpacity: 1,
    strokeWeight: 3,
    zIndex: 1,
    fillOpacity: 0.15,
  }
  if (isSelected) {
    iconPin.url = iconSelected
    pathOptions.strokeColor = s.colorParcelleSelected
    pathOptions.zIndex = 2
    pathOptions.fillOpacity = 0
  }
  // 17 correspond au passage en mode "bâtiments en 3D"
  return map && zoom && zoom > 17 ? (
    <Polygon paths={coordGlobal} options={pathOptions} onClick={onClick} />
  ) : (
    <Marker
      position={center}
      icon={iconPin}
      options={pathOptions}
      onClick={onClick}
    />
  )
}

PolygonMarker.defaultProps = defaultProps
export default PolygonMarker
